import * as types from '../constants';

export const INITIAL_LOTTERY_STATE = {
  lottery: {
    id: null,
    name: '',
    description: '',
    summary: '',
    instructions: '',
    award_message: '',
    lose_message: '',
    open_at: null,
    close_at: null,
    fee: '',
    refundable: false,
    select_number: 0,
    require_acceptance: true,
    acceptance_window: 0,
    max_entries: 1
  },
  create_loading: false,
  create_error: '',
  update_loading: false,
  update_error: '',

  open_lotteries: [],
  future_lotteries: [],
  past_lotteries: [],
  lotteries_loading: false,
  lotteries_error: ''
};

export default function lottery(state = INITIAL_LOTTERY_STATE, action) {
  switch (action.type) {
    case types.FETCH_LOTTERIES_SUCCESS:
      return Object.assign({}, state, {
        open_lotteries: action.payload.open,
        future_lotteries: action.payload.future,
        past_lotteries: action.payload.past,
        lotteries_error: '',
        lotteries_loading: false
      });
    case types.FETCH_LOTTERIES_ERROR:
      return Object.assign({}, state, {
        lotteries_error: action.error,
        lotteries_loading: false
      });
    case types.FETCH_LOTTERIES_START:
      return Object.assign({}, state, {
        open_lotteries: [],
        future_lotteries: [],
        past_lotteries: [],
        lotteries_error: '',
        lotteries_loading: true
      });

    case types.NEW_LOTTERY:
      return Object.assign({}, state, INITIAL_LOTTERY_STATE);

    case types.FETCH_LOTTERY_SUCCESS:
      return Object.assign({}, state, {
        lottery: action.payload,
        update_error: '',
        create_error: ''
      });

    case types.CREATE_LOTTERY_START:
      return Object.assign({}, state, {
        create_loading: true
      });

    case types.CREATE_LOTTERY_SUCCESS:
      return Object.assign({}, state, {
        lottery: action.data,
        create_loading: false,
        create_error: ''
      });

    case types.CREATE_LOTTERY_ERROR:
      return Object.assign({}, state, {
        create_loading: false,
        create_error: action.data
      });

    case types.UPDATE_LOTTERY_START:
      return Object.assign({}, state, {
        update_loading: true
      });

    case types.UPDATE_LOTTERY_SUCCESS:
      return Object.assign({}, state, {
        lottery: action.data,
        update_loading: false,
        update_error: ''
      });

    case types.UPDATE_LOTTERY_ERROR:
      return Object.assign({}, state, {
        update_loading: false,
        update_error: action.data
      });

    default:
      return state;
  }
}
